// Only shared-load pages may override the normal post-login destination.
// Validate the decoded query value exactly; never accept an arbitrary URL.
export function getSharedLoadReturnPath(search) {
	const params = new URLSearchParams(search)
	if (params.get('source') === 'extension') return null
	const next = params.get('next')
	return /^\/(?:multiboard\/)?l\/[A-Za-z0-9_-]{22}$/.test(next || '') ? next : null
}
